import { render, staticRenderFns } from "./ApprovalFileAccessChange.vue?vue&type=template&id=7c38f631"
import script from "./ApprovalFileAccessChange.vue?vue&type=script&lang=js"
export * from "./ApprovalFileAccessChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports